import SEO from "@/components/SEO";
import AboutHero from "./components/AboutHero";
import VisionSection from "./components/VisionSection";
import ValuesSection from "./components/ValuesSection";
import TeamSection from "./components/TeamSection";
import TimelineSection from "./components/TimelineSection";
import CharterSection from "./components/CharterSection";

const siteUrl = import.meta.env.VITE_SITE_URL || "";

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "關於協會｜TAIAA 台灣 AI 應用推廣協會",
  description:
    "了解 TAIAA 的成立宗旨、願景、理監事團隊與組織架構。我們由產學界領袖共同發起，推動 AI 在台灣各產業的實際應用。",
  url: siteUrl ? `${siteUrl}/about` : undefined,
  mainEntity: {
    "@type": "Organization",
    name: "TAIAA 台灣 AI 應用推廣協會",
    url: siteUrl || undefined,
  },
};

export default function About() {
  return (
    <main>
      <SEO
        title="關於協會｜TAIAA 台灣 AI 應用推廣協會"
        description="了解 TAIAA 的成立宗旨、願景、理監事團隊與組織架構。我們由產學界領袖共同發起，推動 AI 在台灣各產業的實際應用。"
        keywords="TAIAA,關於協會,AI 組織,理監事,協會宗旨,台灣 AI"
        schema={aboutSchema}
      />
      <AboutHero />
      <VisionSection />
      <ValuesSection />
      <TeamSection />
      <TimelineSection />
      <CharterSection />
    </main>
  );
}